import { Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { VisitorAuthContext } from '../../../Context/AuthContex/VisitorAuthContext';
import Toaster from '../../../Components/Toaster/Toaster';
import InputField from '../../../Components/Common/InputField';
import Loader from '../../../Components/Spinner/Loader';
import PostDataApis from '../../../Components/Common/FetchData/PostDataApis';

const VisitorChangePassword = () => {
  const { visitorUser } = VisitorAuthContext();
  const Toast = Toaster();
  const { register, handleSubmit, reset } = useForm();
  const { postData, loading, success } = PostDataApis(
    `/api/auth/visitor/change/password`
  );

  const onSubmit = async (value: any) => {
    const { confirm_password, ...data } = value || {};
    data.user_id = visitorUser.visitor_id;
    if (data.new_password !== confirm_password) {
      Toast.fire({
        icon: 'error',
        title: `Password does not match`,
      });

      return;
    }
    if (data?.new_password?.length < 8) {
      Toast.fire({
        icon: 'error',
        title: `Password must be at least 8 characters`,
      });
      return;
    }
    await postData(data);
  };

  useEffect(() => {
    if (success) {
      reset();
    }
  }, [success]);
  return (
    <div className='profile-right-side px-3 py-3'>
      <h4 className='component-tittle'>Change password</h4>
      <div className='pt-2'>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <InputField
              label='Current password'
              register={register('old_password')}
              type='text'
              isRequired
              placeholder='Enter current password'
            />
          </div>
          <div className='py-3'>
            <InputField
              label='New password'
              register={register('new_password')}
              type='text'
              isRequired
              placeholder='Enter new password'
            />
          </div>
          <div>
            <InputField
              label='Re-type new password'
              register={register('confirm_password')}
              type='text'
              isRequired
              placeholder='Retype new password'
            />
          </div>

          <div className='text-end mt-5'>
            {loading ? (
              <Loader css={'submit-button'} />
            ) : (
              <Button type='submit' className='submit-button common-btn'>
                Change password
              </Button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default VisitorChangePassword;
